import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  barcode: null,
  loading: false,
};

export const getAttendanceList = createAsyncThunk(
  "get-attendance",
  async (_, { dispatch }) => {
    try {
      const response = await axios.get("attendance/string");
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAttendanceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAttendanceList.fulfilled, (state, action) => {
        state.loading = false;
        state.barcode = action?.payload?.data?.data?.String;
      })
      .addCase(getAttendanceList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
      });
  },
});

export default attendanceSlice.reducer;
